import { render } from "./StrategicPeriodTable.vue?vue&type=template&id=564945f6"
import script from "./StrategicPeriodTable.vue?vue&type=script&lang=js"
export * from "./StrategicPeriodTable.vue?vue&type=script&lang=js"

import "./StrategicPeriodTable.vue?vue&type=style&index=0&id=564945f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__